import { render } from "./IconFavoriteBorder.vue?vue&type=template&id=b5855142"
import script from "./IconFavoriteBorder.vue?vue&type=script&lang=js"
export * from "./IconFavoriteBorder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__